export default __webpack_public_path__ + "static/media/muted.35805c40.svg";